import React, { useEffect, useContext } from 'react';
import { store } from '../AddOrEdit';
import Chip from '../../../../../../../components/Chip/Chip/Chip';
import Badge from '@material-ui/core/Badge';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    width: '100%',
    marginLeft: theme.spacing(2),
  },
  root: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(2, 0),
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const Categories = () => {
  const classes = useStyles();
  const { state, selectCategory } = useContext(store);
  const { rules, categories } = state;

  const handleClick = (category) => {
    selectCategory(category);
  };

  return (
    <>
      <div className={classes.root}>
        {categories?.length ? (
          categories?.map((category) => (
            <Badge
              key={category._id}
              badgeContent={category.count}
              color="error"
            >
              <Chip
                clickable
                label={category?.name}
                color="primary"
                onClick={() => handleClick(category)}
              />
            </Badge>
          ))
        ) : (
          <div>نقشی یافت نشد!</div>
        )}
      </div>
    </>
  );
};

export default React.memo(Categories);
